// @intent: Pure sprite-placement helpers for native match-3 rendering.
// @flow: layout cells + skin fit -> centered sprite rects with explicit anchors.
// @stale: Keep sprite anchors centralized; generated code should not hand-position tile cutouts.

import type { Match3SkinPackV1 } from '@mintyads/playable-api';
import type { Match3CellRect, Match3Rect } from './Match3Layout.js';

export interface Match3SpritePlacement {
  readonly id: string;
  readonly tileIndex: number;
  readonly row: number;
  readonly col: number;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly anchor: { readonly x: number; readonly y: number };
  readonly assetUrl: string;
  readonly swappable: boolean;
}

export function fitMatch3SpriteRect(cell: Match3CellRect, skin: Match3SkinPackV1): Match3Rect {
  const fill = Math.min(0.98, Math.max(0.55, skin.fit.tileCellFill));
  const size = Math.max(1, cell.width * fill);
  return {
    x: cell.center.x - size / 2,
    y: cell.center.y - size / 2,
    width: size,
    height: size,
  };
}

export function createMatch3SpritePlacement(
  input: {
    readonly id: string;
    readonly cell: Match3CellRect;
    readonly skin: Match3SkinPackV1;
    readonly assetUrl: string;
    readonly swappable: boolean;
  },
): Match3SpritePlacement {
  const rect = fitMatch3SpriteRect(input.cell, input.skin);
  return {
    id: input.id,
    tileIndex: input.cell.tileIndex,
    row: input.cell.row,
    col: input.cell.col,
    x: input.cell.center.x,
    y: input.cell.center.y,
    width: rect.width,
    height: rect.height,
    anchor: input.skin.fit.anchor,
    assetUrl: input.assetUrl,
    swappable: input.swappable,
  };
}
